export interface DomainMetadata {
  code: DomainCode;
  name: string;
  slug: string;
  color: string;
}

export type DomainCode = "HE" | "LA" | "SC" | "AR" | "SO";

const DOMAIN_DEFINITIONS: DomainMetadata[] = [
  { code: "HE", name: "健康领域", slug: "health", color: "#14b8a6" },
  { code: "LA", name: "语言领域", slug: "language", color: "#6366f1" },
  { code: "SC", name: "科学领域", slug: "science", color: "#f97316" },
  { code: "AR", name: "艺术领域", slug: "art", color: "#ef4444" },
  { code: "SO", name: "社会领域", slug: "social", color: "#0ea5e9" }
];

const DOMAIN_NAME_LOOKUP = new Map<string, DomainMetadata>(
  DOMAIN_DEFINITIONS.map((domain) => [domain.name, domain]),
);

const DOMAIN_CODE_LOOKUP = new Map<DomainCode, DomainMetadata>(
  DOMAIN_DEFINITIONS.map((domain) => [domain.code, domain]),
);

export function getDomainByName(name: string): DomainMetadata {
  const domain = DOMAIN_NAME_LOOKUP.get(name.trim());
  if (!domain) {
    throw new Error(`Unknown domain name: ${name}`);
  }
  return domain;
}

export function getDomainByCode(code: DomainCode): DomainMetadata {
  const domain = DOMAIN_CODE_LOOKUP.get(code);
  if (!domain) {
    throw new Error(`Unknown domain code: ${code}`);
  }
  return domain;
}

export function listDomains(): DomainMetadata[] {
  return [...DOMAIN_DEFINITIONS];
}
